export default {
  SET_PURL_ID(state, purlId) {
    state.id = purlId;
  },
  SET_SESSION_DB_ID(state, sessionDbId) {
    state.sessionDbId = sessionDbId;
  },
  SET_IS_PREVIEW(state, isPreview) {
    state.isPreview = isPreview;
  },
  SET_PURL_INFO(state, purl) {
    state.client = purl.client;
    state.rep = purl.rep;
    state.pages = purl.pages;
  },
  SET_CMS_INFO(state, cms) {
    state.allCmsPages = cms;
  },
};
